module.exports = require("lodash.multiply")